// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
// import team3 from 'assets/img/team/3.jpg';
// import Avatar from 'components/common/Avatar';
import paths from 'routes/paths';

import  { useSelector } from 'react-redux'


//  START Codice per gestione logout con Msal
import { useMsal } from '@azure/msal-react';

const handleLogoutRedirect = (instance) => {
  // console.log('handleLogoutRedirect');
  instance.logoutRedirect();
};
/*
const handleLogoutPopup = (instance) => {
  // console.log('handleLogoutPopup');
  instance.logoutPopup({
    mainWindowRedirectUri: '/' // redirects the top level app after logout
  });
};
*/
//  END Codice per gestione logout con Msal


const ProfileDropdown = () => {
  //  START Codice per gestione logout con Msal
  const { instance } = useMsal();
  //  END Codice per gestione logout con Msal

  //  START CODICE PER LETTURA UTENTE CORRENTE DA REDUX STORE
  const name = useSelector((state) => state.utenteCorrente.name);
  //  const questionarioUUID  = useSelector((state) => state.datiGenerali.questionarioUUID);

  //  Come veviva richiamato l'Avatar dell'utente nel tema origine:
  //  <Avatar src={team3} />

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
         {name}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">

          <Dropdown.Item as={Link} to={paths.cardLogout} onClick={() => handleLogoutRedirect(instance)}>
            Esci
          </Dropdown.Item>

        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;

/*
      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item className="fw-bold text-warning" href="#!">
            <FontAwesomeIcon icon="crown" className="me-1" />
            <span>Go Pro</span>
          </Dropdown.Item>

          <Dropdown.Divider />

          <Dropdown.Item href="#!">Set status</Dropdown.Item>

          <Dropdown.Item as={Link} to={paths.userProfile}>
            Profile &amp; account
          </Dropdown.Item>

          <Dropdown.Item href="#!">Feedback</Dropdown.Item>
          <Dropdown.Divider />

          <Dropdown.Item as={Link} to={paths.userSettings}>
            Settings
          </Dropdown.Item>

          <Dropdown.Item as={Link} to={paths.cardLogout} onClick={() => handleLogoutRedirect(instance)}>
            Esci
          </Dropdown.Item>

        </div>
      </Dropdown.Menu>


          <Dropdown.Item as={Link} to={paths.cardLogout}>
            Logout
          </Dropdown.Item>

          <Dropdown.Item as={Link} to={paths.cardLogout} onClick={() => handleLogoutRedirect(instance)}>
            Esci con Redirect (Msal)
          </Dropdown.Item>

          <Dropdown.Item as="button" onClick={() => handleLogoutRedirect(instance)}>
            Sign out using Redirect (Msal)
          </Dropdown.Item>

*/